<mbs-modal
  [title]="baseModal.data.title"
  [isCustomModal]="true"
  [showFooter]="true"
  [showCloseCross]="!this.codes?.length"
  [titleTextOverflow]="true"
  #modal>
  <ng-container modal-body>
    <mbs-google-qr-code
      *ngIf="isGoogleAuth === true && !isValidate"
      (onQRCodeSet)="onQRCodeSet($event)"
      (onToggleAuthType)="isGoogleAuth = false"></mbs-google-qr-code>

    <ng-container *ngIf="isGoogleAuth !== true && !isValidate">
      <mbs-msp-qr-code
        [QRCodeUri]="baseModal.data.qrCodeUrl"
        [timeExpired]="baseModal.data.timeExpired"
        [isEnableTFA]="baseModal.data.isEnableTFA"
        [isDeviceModal]="baseModal.data.isDeviceModal">
      </mbs-msp-qr-code>
      <mbs-install-msp-app-instruction></mbs-install-msp-app-instruction>
      <div
        *ngIf="showThirdPartyAuthButton"
        class="d-flex align-items-center mt-4 justify-content-center">
        <mbs-button
          [id]="'third-auth-button'"
          [isCtrl]="true"
          icon="fa fa-refresh"
          (click)="isGoogleAuth = true">
          {{ 'shared:tfa.mspQRCode.useThirdAuthenticator' | i18next }}
        </mbs-button>
      </div>
    </ng-container>

    @if (isValidate) {
      <mbs-recovery-code
        [codes]="codes"
        [authId]="authId"></mbs-recovery-code>

      <mbs-reserve-auth-panel
        (enabling)="isReserveAuthProcessOngoing = $event"
        (confirmed)="isReserveAuthProcessCompleted = true"
        [authId]="authId"
        class="mt-4"></mbs-reserve-auth-panel>
    }
  </ng-container>

  <ng-container modalFooter>
    <div class="d-flex justify-content-between w-100">
      <mbs-checkbox
        [(ngModel)]="isSavedRecoveryCodes"
        *ngIf="isValidate"
        label="{{ 'shared:tfa.recoveryCode.savedCheckbox' | i18next }}"></mbs-checkbox>
      <mbs-button
        type="primary"
        data-dismiss="modal"
        *ngIf="isValidate"
        [disabled]="!isFinishAvailable"
        (click)="modal.save(true)">
        {{ 'shared:tfa.finish' | i18next: { format: 'title' } }}
      </mbs-button>
    </div>
  </ng-container>
</mbs-modal>
